/* Lightweight toast stack — bottom-right, auto-dismissing.
   Used by chat dashboard actions (highlight_region fallbacks, save_view
   confirmations, unsupported-action notices). */

import { useToasts, type Toast } from "./store"

const KIND_CLASSES: Record<Toast["kind"], string> = {
  info: "border-sky-500/40 bg-sky-500/10 text-sky-200",
  warn: "border-amber-500/40 bg-amber-500/10 text-amber-200",
  success: "border-emerald-500/40 bg-emerald-500/10 text-emerald-200",
}

export function Toasts() {
  const toasts = useToasts((s) => s.toasts)
  const dismiss = useToasts((s) => s.dismissToast)

  if (toasts.length === 0) return null

  return (
    <div
      className="fixed bottom-10 right-3 z-[70] flex flex-col gap-2 max-w-sm"
      role="status"
      aria-live="polite"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`ui-panel--glass rounded border px-3 py-2 text-[11px] leading-snug shadow-lg flex items-start gap-2 ${KIND_CLASSES[t.kind]}`}
        >
          <span className="flex-1">{t.text}</span>
          <button
            type="button"
            aria-label="Dismiss notification"
            onClick={() => dismiss(t.id)}
            className="shrink-0 text-sm leading-none opacity-60 hover:opacity-100"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  )
}
